import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { User } from '@app/_models';
import { CommonUtility } from '@app/_modules/commonUtility';
import { environment } from '@environments/environment';
import { Observable } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
@Injectable({ providedIn: 'root'
})
export class CategoryService {
  commonUtility:CommonUtility;
  Base_url;
  isgPay_url;
  constructor(
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {
    this.Base_url = environment.Base_url;
    this.isgPay_url =environment.isgPayUrl;
    this.commonUtility = new CommonUtility(snackBar);
  }

  initiateDonationPayment(req,token){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
        'token' : token
      });
      let url = `${this.Base_url}cessservice/initiateDonationPayment`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }
  }



